import { FC } from 'react';

import { SearchSuggestionClickHandler } from '../../model';
import { ListSuggestionItem } from './ListSuggestionItem';
import { ListSuggestionsWrapper } from './ListSuggestions.styles';
import { ListSuggestionItemProps } from './model';

type Props = {
    items: ListSuggestionItemProps[];
    onClick?: SearchSuggestionClickHandler;
};

export const ListSuggestions: FC<Props> = ({ items, onClick }) => {
    if (!items?.length) {
        return null;
    }

    return (
        <ListSuggestionsWrapper>
            {items.map((item, index) => (
                <ListSuggestionItem
                    keyword={item.keyword}
                    url={item.url}
                    isHistory={item.isHistory}
                    key={index}
                    onDelete={item.onDelete}
                    searchText={item.searchText}
                    onClick={(event) => onClick?.(event, { suggestion: item.keyword, queryKey: item.queryKey })}
                />
            ))}
        </ListSuggestionsWrapper>
    );
};
